<template>
  <!-- eslint-disable -->
  <div v-if="isLoading === false" id="app">
    <Header />
    <MainContent>
      <router-view />
    </MainContent>

    <div v-if="isShow">
      <a
        style="
          outline: none !important;
          visibility: visible !important;
          resize: none !important;
          overflow: visible !important;
          background: #03a84e !important;
          opacity: 1 !important;
          position: fixed !important;
          border: 0px !important;
          padding: 0px !important;
          transition-property: none !important;
          z-index: 1000001 !important;
          cursor: auto !important;
          float: none !important;
          pointer-events: auto !important;
          box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 10px 0px !important;
          height: 60px !important;
          min-height: 60px !important;
          max-height: 60px !important;
          width: 60px !important;
          min-width: 60px !important;
          max-width: 60px !important;
          border-radius: 50% !important;
          transform: rotate(0deg) translateZ(0px) !important;
          transform-origin: 0px center !important;
          margin: 0px !important;
          top: auto !important;
          bottom: 45px !important;
          right: 10px !important;
          left: auto !important;
          display: block !important;
          cursor: pointer;
        "
        href="mailto:it.helpdesk@etonhouse.edu.sg?subject=Kagami%20Feedback"
      >
        <i class="fa fa-envelope fa-2x" aria-hidden="true" style="color: #ffffff; margin: 15px auto"></i>
      </a>
    </div>

    <b-modal id="modaltimeout" hide-footer title="SESSION EXPIRED" v-model="isSessionModalOpen">
      Session expired, press ok to continue login, press cancel to logout
      <br />
      <div class="row d-flex submit-wrap">
        <div class="col-md-6">
          <b-btn class="float-left" @click="cancelClick">Cancel</b-btn>
        </div>
        <div class="col-md-6">
          <b-btn class="float-right" @click="okClick">OK</b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Header from './components/Header'
import MainContent from './components/MainContent'
import DataSource from './data/datasource'
import Cookies from 'js-cookie'
import Global from './global'
import './assets/bootstrap.min.css'
import 'material-icons/iconfont/material-icons.css'
import '../src/config/scss/base.scss'
import '../src/config/scss/_variable.scss'
import { getStaffPortalStatus } from '@/helper/util_custom'

export default {
  name: 'app',
  data() {
    return {
      isLoading: true,
      token: null,
      isLoggedIn: null,
      isSessionModalOpen: false,
      isShow: false,
    }
  },
  components: {
    MainContent,
    Header,
  },
  mounted() {
    const shouldAuth = this.$route.path.toLowerCase() === '/public/payment'

    if (getStaffPortalStatus) {
      this.isShow = true
    }

    if (this.$route.path.toLowerCase().startsWith('/public/')) {
    } else {
      if (this.checkUserAgent() && window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API4.toUpperCase())) {
        // console.log("mobile");
        // if (this.$route.path === "/ParentRegisterByLink") {
        //
        //   if (this.$route.query.id !== undefined) {
        //         let otherLink = "";
        //         otherLink = process.env.VUE_APP_ROOT_API5 + '' + this.$route.path + '?id=' +
        //             encodeURIComponent(this.$route.query.id);
        //
        //         // console.log(otherLink, "hihi");
        //         window.location.replace(otherLink);
        //     } else {
        //         window.location.replace(process.env.VUE_APP_ROOT_API5);
        //     }
        // } else {
        //     window.location.replace(process.env.VUE_APP_ROOT_API5);
        // }
        // window.location.replace(process.env.VUE_APP_ROOT_API5);
      }
    }

    // const isLogin = Cookies.get('authToken');
    // if (this.$route.path !== "/login" &&
    //     this.$route.path !== "/register/parent" &&
    //     this.$route.path !== "/reset-password" &&
    //     this.$route.path !== "/reset-email" &&
    //     this.$route.path !== "/PortfolioMedia" &&
    //     this.$route.path !== "/SecretAdminConfigPage" &&
    //     this.$route.path !== "/ParentRegisterByLink" &&
    //     (!isLogin || isLogin === "null" || isLogin === "undefined") &&
    //     !this.$route.path.startsWith("/public/")) {
    //     // alert("expired");
    //     this.$message.error('Session is expired, please login again.');
    //     this.$router.push('/login');
    // } else if (isLogin) {
    //     this.isLoggedIn = true;
    //     this.checkExpireCookies();
    //     // setTimeout(this.warningLogout, 10800000); // 3 hours
    // }
    // if (isLogin === null || isLogin === "undefined") {
    //     this.$router.push('/login');
    // }
    // this.isLoading = false;

    const isLogin = Cookies.get('authToken')

    if (this.$route.path.toLowerCase().startsWith('/public/')) {
      //no action here because public can be access by login or no login
      console.log('public link')
      if (this.$route.path.toLowerCase() === '/public/studentapplicationform') {
        document.title = 'EtonHouse Application Form'
      }
    } else if (
      // if below page only no login can access
      this.$route.path === '/login' ||
      this.$route.path === '/register/parent' ||
      this.$route.path === '/reset-password' ||
      this.$route.path === '/reset-email' ||
      this.$route.path === '/PortfolioMedia' ||
      // this.$route.path === "/SecretAdminConfigPage" ||
      this.$route.path === '/ParentRegisterByLink'
    ) {
      if (isLogin !== null && isLogin !== undefined && isLogin !== '' && isLogin !== 'undefined') {
        this.$router.push('/')
      }
    } else if (isLogin === null || isLogin === undefined || isLogin === '' || isLogin === 'undefined') {
      this.$router.push('/login')
    } else {
      this.isLoggedIn = true
      this.checkExpireCookies()

      if (Cookies.get('userTypeSession') !== 'Parent') {
        document.title = Cookies.get('userSchoolNameSession')
      }
    }

    // if (window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API3.toUpperCase())) {
    //     if (!window.location.host.toUpperCase().includes('LOCALHOST'))  {
    //         $(document).ready(function(){
    //             var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    //             (function(){
    //                 var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    //                 s1.async=true;
    //                 s1.src='https://embed.tawk.to/5cecd9c2a667a0210d59bf86/default';
    //                 s1.charset='UTF-8';
    //                 s1.setAttribute('crossorigin','*');
    //                 s0.parentNode.insertBefore(s1,s0);
    //             })();
    //         });
    //     }
    // }
    // if (window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API4.toUpperCase())) {
    //     if (!window.location.host.toUpperCase().includes('LOCALHOST'))  {
    //         $(document).ready(function(){
    //             var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    //             (function(){
    //                 var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    //                 s1.async=true;
    //                 s1.src='https://embed.tawk.to/5e8a8e5869e9320caac08d87/default';
    //                 s1.charset='UTF-8';
    //                 s1.setAttribute('crossorigin','*');
    //                 s0.parentNode.insertBefore(s1,s0);
    //             })();
    //         });
    //     }
    // }

    this.isLoading = false
  },
  methods: {
    appGetMs() {
      const d = new Date()
      return d.getTime()
    },
    checkExpireCookies() {
      const expireTime = Cookies.get('expireTime')
      const nowMs = this.appGetMs()
      let newExpireTime = new Date(Number(expireTime) + 1 * 60 * 1000)
      let newCheckExpireTime = newExpireTime - nowMs
      setTimeout(() => {
        if (!expireTime || expireTime < nowMs) {
          DataSource.shared.logout()
        } else {
          this.checkExpireCookies()
        }
      }, newCheckExpireTime)

      // let timeout = 1 * 60 * 1000;
      // console.log(timeout)
      // setTimeout(() => {
      //     let withToken = Cookies.get('authToken');
      //     if (!withToken) {
      //         DataSource.shared.logout();
      //         // console.log("withToken");
      //     }else{
      //         this.checkExpireCookies();
      //     }
      // }, timeout);
    },
    warningLogout() {
      this.isSessionModalOpen = true
      // const result = "Session expired, press ok to continue login, press cancel to logout";
      setTimeout(this.cancelClick, 10800)
    },
    okClick() {
      // continue login
      // repeating after some time warning session expired
      setTimeout(this.warningLogout, 10800000) // 3 hours
      this.isSessionModalOpen = false
    },
    cancelClick() {
      console.log('logout clicked')
      DataSource.shared.logout()
      Cookies.remove('authToken')
    },

    checkUserAgent() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>
<style>
body {
}

.el-table th > .cell {
  white-space: nowrap;
}

#app {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif, 'KaiTi';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f1f1f1;
  font-size: 0.9rem;
}

.white-box {
  background: #fff;
  padding: 15px;
  border-radius: 2px;
  box-shadow: 1px 1px 4px #e0e0e0;
  margin: 5px 0;
}

a {
  text-decoration: none !important;
}

.loading-screen {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(255, 255, 255, 0.63);
  color: #000;
  top: 0;
  left: 0;
  font-size: 30px;
}
</style>
<style lang="scss">
$theme-colors: (
  primary: #f44252,
);
</style>
